import type { RouteRecordRaw } from 'vue-router';
import { ERouteName } from '~/app/router/routeName.enum';

export const aboutPageRoutes: RouteRecordRaw[] = [
  {
    name: ERouteName.ABOUT,
    path: '/about',
    component: () => import('~/pages/about/index.client.vue'),
  },

  {
    name: ERouteName.ABOUT_CAREERS,
    path: '/about/careers',
    component: () => import('~/pages/about/index.client.vue'),
  },

  {
    name: ERouteName.ABOUT_CONTACT,
    path: '/about/contact',
    component: () => import('~/pages/about/index.client.vue'),
  },

  {
    name: ERouteName.ABOUT_DELIVERY_POINTS,
    path: '/about/delivery-points',
    component: () => import('~/pages/about/index.client.vue'),
  },
];
